import Vue from 'vue';
import Toasted from 'vue-toasted';

Vue.use(Toasted, {
  position: 'top-right',
  containerClass: 'toast-container',
  className: 'toast-kks',
  duration: 7000,
});
